import { Component, Input, Output, EventEmitter, ElementRef } from '@angular/core';

@Component({
  selector: 'ola-faq-answer',
  template: require('./faq-answer.component.html'),
  styles: [require('./faq-answer.component.scss')]
})
export class FaqAnswerComponent {
  @Input() active;
  @Input() answer;
  @Input() faqId;
  @Input() actions;
  @Output() emittedAction = new EventEmitter();

  constructor(elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  ngOnInit() {
    this.hasActions = this.actions && this.actions.length;
  }

  ngAfterViewInit() {
    if (this.hasActions) {
      this.bindUnbindEvents(true);
    }
  }

  ngOnDestroy() {
    if (this.hasActions) {
      this.bindUnbindEvents(false);
    }
  }

  bindUnbindEvents(bool) {
    this.actions.forEach(link => {
      const el = this.elementRef.nativeElement.querySelector(`#${link.id}`);
      if (el) {
        if (bool) {
          if (!el.hasAttribute('allytmln')) {
            const allytmln = link.allytmln || link.id;
            el.setAttribute('allytmln', allytmln);
          }
          el.addEventListener('click', (e) => this.fireAction(e, link.action));
          el.addEventListener('keydown', (e) => this.fireAction(e, link.action));
        } else {
          el.removeEventListener('click', (e) => this.fireAction(e, link.action));
          el.removeEventListener('keydown', (e) => this.fireAction(e, link.action));
        }
      }
    });
  }

  fireAction(event, action) {
    if (event.type === 'click' || event.type === 'keydown' && event.key === 'Enter') {
      this.emittedAction.emit(action);
    }
  }
}
